import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Link } from "react-router-dom";


class DisplayReferences extends Component {

    displayReferenceIds(calendarEvent) {

        let refIds = []

        if (calendarEvent.quoteIdentifier) {
            refIds.push(
                <Link key={calendarEvent.quoteId} to={'/quotes/' + calendarEvent.quoteId + '/edit'}>
                    {calendarEvent.quoteIdentifier}
                </Link>)
        }
        if (calendarEvent.orderIdentifier) {
            refIds.push(
                <Link key={calendarEvent.orderId} to={'/orders/' + calendarEvent.orderId + '/edit'}>
                    {calendarEvent.orderIdentifier}
                </Link>)
        }
        if (calendarEvent.invoiceIdentifier) {
            refIds.push(
                <Link key={calendarEvent.invoiceId} to={'/invoices/' + calendarEvent.invoiceId + '/edit'}>
                    {calendarEvent.invoiceIdentifier}
                </Link>)
        }
        if (calendarEvent.schedulingPageIdentifier) {
            refIds.push(
                <Link key={calendarEvent.invoiceId} to={'/scheduling-pages/' + calendarEvent.schedulingPageId + '/edit'}>
                    {calendarEvent.schedulingPageIdentifier}
                </Link>)
        }

        const priceListReferences = calendarEvent.priceListReferences
        if (priceListReferences) {
            priceListReferences.forEach(reference => {
                refIds.push(
                    <Link key={reference.priceListId} to={'/price-lists/' + reference.priceListId + '/edit'}>
                        {reference.priceListIdentifier}
                    </Link>)
            });
        }

        return refIds

    }

    render() {
        const referenceIds = this.displayReferenceIds(this.props.calendarEvent)
        return (
            referenceIds.map((item, index) => (
                <span key={item.key}>
                    {item}
                    {index < referenceIds.length - 1 && ', '}
                </span>
            ))
        )
    }

}

export default injectIntl(DisplayReferences)


// WEBPACK FOOTER //
// ./src/scheduling-page/displayreferences.component.jsx